module.exports = __webpack_public_path__ + "static/media/polygon.fa25eced.svg";